import React, { useEffect, useState } from "react";
import { StyledInputBase } from "common/components/Input/TextInput";
import { formatDateTime } from "common/utils/dateUtil";
import styled from "styled-components";
import { InputWrapper } from "common/components/Wrapper/InputBase"; // 달력 아이콘 SVG 가정
import { openGlobalModal } from "common/utils/modalController";
import { DatePicker } from "../Etc/calendar/DatePicker";

const IconWrapper = styled.div`
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export default function DateField({
  label,
  name,
  placeholder,
  defaultDate,
  style,
  onChange,
}) {
  const [value, setValue] = useState(defaultDate || formatDateTime(new Date()));

  useEffect(() => {
    setValue(defaultDate);
  }, [defaultDate]);

  return (
    <InputWrapper label={label}>
      <StyledInputBase
        type={"date"}
        name={name}
        placeholder={placeholder}
        value={value}
        // onClick={() => {
        //   openGlobalModal({ content: <DatePicker /> });
        // }}
        onChange={(e) => {
          setValue(e.target.value);
          onChange?.(e.target.value);
        }}
        style={{ boxSizing: "border-box", ...style }}
      />
    </InputWrapper>
  );
}
